import { render } from "./ShowcaseWall.vue?vue&type=template&id=33bdaace&scoped=true"
import script from "./ShowcaseWall.vue?vue&type=script&lang=js"
export * from "./ShowcaseWall.vue?vue&type=script&lang=js"

import "./ShowcaseWall.vue?vue&type=style&index=0&id=33bdaace&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bdaace"]])

export default __exports__